/**
 * Thrown by the auth factory's signIn when Keycloak needs the user to set a new password on
 * its hosted pages first (keycloak-password-update.ts). Login.tsx shows PasswordUpdateNotice.
 */
export class PasswordUpdateRequiredError extends Error {
  readonly actionUrl: string
  readonly email: string

  constructor(actionUrl: string, email: string) {
    super('Password update required')
    this.name = 'PasswordUpdateRequiredError'
    this.actionUrl = actionUrl
    this.email = email
  }
}
